import { Modal } from "./modal";
export * from "./modal";
export var MODAL_DIRECTIVES = [
    Modal
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/modal/index.js
// module id = 196
// module chunks = 4